// extracted by mini-css-extract-plugin
module.exports = {"background":"_2+QD3","confirm":"H1f1M","dialogue":"YCN6e"};